import Repository from "./Repository";

export default {
  /*
   * deactivate circle
   */
   deactivate(id) {
    return Repository.get(`/useraccountdeactivate/?circle_id=${id}`);
  },
  /**
   * delete individual role account
   */
  delete(id) {
    return Repository.get(`/useraccountdelete/?circle_id=${id}`);
  },
  /**
   * delete account
   */
  deleteAll() {
    return Repository.get(`/useraccountdelete/`);
  },
  /*
   * activate circle
   */
  activate(id) {
    return Repository.get(`/useraccountactivate/?circle_id=${id}`);
  },
};



// WEBPACK FOOTER //
// ./src/repositories/leaveCircleRepository.js